import { Box, Skeleton, Stack } from '@mui/material';
import { useParams } from 'react-router-dom';
import FileSetSectionTable from 'src/features/detailSections/FileSetSectionTable';
import {
  FILES_SECTION,
  OUTSIDE_PATH_RULES_SECTION,
  PUBLISHERS_SECTION,
  WRITABLE_FOLDERS_SECTION,
} from 'src/features/detailSections/sections';
import { useApplication } from 'src/hooks/applications';

const SIDE_BY_SIDE_MIN_HEIGHT = 110;
const SIDE_BY_SIDE_MAX_HEIGHT = 260;

// This customer application names one file set, and its details are that set's details, so the page
// reads the same endpoints the file set modal does rather than duplicates keyed on the application.
const AppDetailsSection = () => {
  const { appId } = useParams();
  const { isLoading, data: app } = useApplication({ applicationId: appId });

  if (isLoading || !app) {
    return <Skeleton variant="rounded" height={280} sx={{ bgcolor: '#484848' }} />;
  }

  const sectionTable = (section, props) => (
    <FileSetSectionTable
      globalApplicationVersionId={app.globalApplicationVersionId}
      fileSetId={app.fileSetId}
      section={section}
      {...props}
    />
  );

  return (
    <Stack spacing={2}>
      {sectionTable(FILES_SECTION, { maxHeight: 340 })}
      {sectionTable(PUBLISHERS_SECTION, { maxHeight: 220 })}

      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems="stretch">
        {[OUTSIDE_PATH_RULES_SECTION, WRITABLE_FOLDERS_SECTION].map(section => (
          <Box key={section.key} sx={{ flex: 1, minWidth: 0, display: 'flex' }}>
            {sectionTable(section, {
              fill: true,
              minHeight: SIDE_BY_SIDE_MIN_HEIGHT,
              maxHeight: SIDE_BY_SIDE_MAX_HEIGHT,
            })}
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};

export default AppDetailsSection;
